import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Bold, Sparkles, Regular } from '@zazume/zzm-base';
import { useI18n } from '#hooks/useI18n';

const Container = styled.div(({ theme }) => css`
  padding: ${theme.spacing.s24} ${theme.spacing.s7};
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.s5};

  ${theme.mq.md} {
    padding: ${theme.spacing.s24} ${theme.spacing.s12};
  }
`);

const Card = styled.div(({ theme }) => css`
  text-align: center;
  max-width: 350px;
  background: ${theme.colors.Gray100};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${theme.spacing.s4};
  align-items: center;
  padding: 28px 30px;
  border-radius: 20px;
  border: 1.5px solid ${theme.colors.Gray200};
`);

export const IntroBody = () => {
  const { t } = useI18n();
  return (
    <Container>
      <Card>
        <Sparkles size={40} color="Primary"/>
        <Bold variant="XL">Zazume Copilot</Bold>
        <Regular color="Gray500">{t('copilot.emptystate')}</Regular>
      </Card>
    </Container>
  );
};
